import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './components/banner/banner.component';
import { SharedModule } from '../../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { StoryImgSliderModule } from '../story-img-slider/story-img-slider.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MatButtonModule,
    StoryImgSliderModule,
    MatIconModule
  ],
  declarations: [BannerComponent],
  exports: [BannerComponent],
})
export class BannerModule { }
